/* eslint-disable unused-imports/no-unused-imports */
import React from 'react';
import Cookies from 'js-cookie';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useNavigate } from 'react-router-dom';
// mui
import KeyIcon from '@mui/icons-material/Key';
import LockIcon from '@mui/icons-material/Lock';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';

const APNavBar = () => {
  const navigate = useNavigate();
  const adminID = Cookies.get('adminID');

  const handleLogout = () => {
    try {
      Cookies.remove('token');
      Cookies.remove('adminID');
      Cookies.remove('adminName');
      Cookies.remove('adminuser_type');

      window.location.reload();

      navigate('/admin');
    } catch (error) {
      console.error('Couldn\'t log out');
    }
  };

  return (
    <div className='APNavbar'>
      <Navbar expand='lg' className='defaultnavbar'>
        <div className='APNavSectionLeft'>
          <Link to='/admin/admins/dashboard'>
            <Navbar.Brand>
              <img
                alt='Logo'
                width='50px'
                src='/Images/Logo.png'
                className='frontendNavLogo'
              />
            </Navbar.Brand>
          </Link>
        </div>
        <Navbar.Toggle aria-controls='navbarScroll' />
        <Navbar.Collapse id='navbarScroll' className='navbardefault'>
          <Nav
            navbarScroll
            style={{ fontSize: '18px' }}
            className='ms-auto my-2 my-lg-0 navigation'
          >
            <div className='APNavSectionRight'>
              <div className='part1'>
                <Link to='/admin/users' className='SearchIcon'>
                  <i>
                    <img src='/Images/adminpanel/search.svg' alt='Search' />
                  </i>
                </Link>
                <Link to='' className='bellIndicator'>
                  <i>
                    <img
                      alt='Bell'
                      className='bell'
                      src='/Images/adminpanel/bell.svg'
                    />
                  </i>
                  <i>
                    <img
                      alt='Bell'
                      className='indicator'
                      src='/Images/adminpanel/indicator.svg'
                    />
                  </i>
                </Link>
              </div>
              <div className='part2'>
                <div className='APNavInner1'>
                  <Link to='/admin/admins/dashboard' className='SearchIcon'>
                    <i>
                      <img src='/Images/adminpanel/avatar.png' alt='Avatar' />
                    </i>
                  </Link>
                </div>
                <div className='APNavInner3'>
                  <div className='dropdown'>
                    <Link
                      type='button'
                      aria-expanded='false'
                      id='dropdownMenuButton1'
                      data-bs-toggle='dropdown'
                      class='dropdown-toggle SearchIcon'
                    >
                      {adminID === '1' && 'Admin'}
                      {adminID === '0' && 'Sub-Admin'}
                    </Link>
                    <ul
                      aria-labelledby='dropdownMenuButton1'
                      className='dropdown-menu custom-dropdown-menu'
                    >
                      <div className='row'>
                        <div className='dropdownMenu col-md-4 text-black'>
                          <Link to='/admin/admins/changeusername'>
                            <PersonIcon />
                            Change Username
                          </Link>
                        </div>
                        <div className='dropdownMenu col-md-4'>
                          <Link to='/admin/admins/changepassword'>
                            <LockIcon />
                            Change Password
                          </Link>
                        </div>
                        <div className='dropdownMenu col-md-4'>
                          <Link to='/admin/admins/changeemail'>
                            <EmailIcon />
                            Change Email
                          </Link>
                        </div>
                      </div>
                      <Link onClick={() => handleLogout()}>
                        <div className='dropdownMenuLower row'>
                          <div className='col-md-12'>
                            <KeyIcon />
                            Logout
                          </div>
                        </div>
                      </Link>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default APNavBar;
